module.exports = __webpack_public_path__ + "img/consultoria2_4-3_1536.2089e8ff.jpg";